import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    scrollContent: {
      padding: 20,
      gap: 20,
    },
    subtitle: {
      fontSize: 15,
      lineHeight: 22,
    },
    label: {
      fontSize: 13,
      fontWeight: '600',
      letterSpacing: 0.5,
      marginBottom: 10,
    },
    typeRow: {
      flexDirection: 'row',
      gap: 10,
    },
    typeChip: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      paddingVertical: 10,
      borderRadius: 10,
      borderWidth: 1.5,
    },
    typeChipText: {
      fontSize: 13,
      fontWeight: '600',
    },
    textArea: {
      borderWidth: 1,
      borderRadius: 10,
      padding: 14,
      fontSize: 15,
      minHeight: 140,
      textAlignVertical: 'top',
    },
    charCount: {
      fontSize: 12,
      textAlign: 'right',
      marginTop: 4,
    },
    submitButton: {
      borderRadius: 12,
      padding: 16,
      alignItems: 'center',
      marginTop: 8,
    },
    submitButtonText: {
      fontSize: 16,
      fontWeight: '700',
    },
  });
